import { FaBars} from "react-icons/fa";
import {AiOutlineClose} from 'react-icons/ai';
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  background: transparent;
  height: 80px;
  display: flex;
  justify-content: space-between;
  //padding: 0.5rem calc((100vw - 1000px) / 2);
  padding-right: 25px;
  z-index: 100;
  /* Third Nav */
  /* justify-content: flex-start; */
`;

export const NavLink = styled(Link)`
  font-family: "Paytone One";
  font-size: 1.5vw;
  color: black;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 1rem calc(max(1vw, 10px));
  height: 100%;
  cursor: pointer;
  white-space: nowrap;
  &.active {
    //text-shadow: grey 0px 1px 1px;
    color: red;
    text-decoration: underline black;
  }

  &.hover {
    //text-shadow: grey 0px 1px 1px;
    //color:black;
    color: red;
    text-underline: black;
  }

  @media screen and (max-width: 1300px) {
    font-size: 18px;
    padding: 1rem 10px;
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: black;
  z-index: 51;
  @media screen and (max-width: 1199px) {
    display: block;
    position: absolute;
    float: right;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const Cross = styled(AiOutlineClose)`
  display: none;
  color: black;
  z-index: 51;
  @media screen and (max-width: 1199px) {
    display: block;
    position: absolute;
    float: right;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;
  /* Second Nav */
  /* margin-right: 24px; */
  /* Third Nav */
  /* width: 100vw;
  white-space: nowrap; */
  //@media screen and (max-width: 768px) {
  //  display: none;
  //}
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;
  /* Third Nav */
  /* justify-content: flex-end;
  width: 100vw; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: #256ce1;
  padding: 10px 22px;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  /* Second Nav */
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    //background: #fff;
    text-shadow: grey 0px 1px 1px;
  }
`;
